'use client';

import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

interface ConditionBatteryLevelProps extends PropsWithChildren {
  low?: string;
  average?: string;
  high?: string;
  unknown?: string;
}

export const ConditionBatteryLevel: FC<ConditionBatteryLevelProps> = ({
  low,
  average,
  high,
  unknown,
  children,
}) => {
  const { dataBlocks } = useTruth();
  const { batteryLevel, batteryChargingStatus } = dataBlocks;
  const { DataPopup } = useDataPopup();
  const [handle, setHandle] = useState<React.ReactNode>(children);

  useEffect(() => {
    const value = batteryLevel?.value;
    if (typeof value === 'undefined') {
      setHandle(unknown);
    } else if (+value < 35) {
      setHandle(low);
    } else if (+value > 75) {
      setHandle(high);
    } else {
      setHandle(average);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- branch props are static JSX; keyed on the detected value
  }, [batteryLevel?.value]);

  return (
    <DataPopup
      handle={handle}
      condition={{
        title: messages['condition.batteryLevel'],
        options: [
          {
            title: messages['condition.batteryLevel.low'],
            value: low,
          },
          {
            title: messages['condition.batteryLevel.average'],
            value: average,
          },
          {
            title: messages['condition.batteryLevel.high'],
            value: high,
          },
          {
            title: messages['condition.batteryLevel.unknown'],
            value: unknown,
          },
        ],
      }}
      dataBlocks={{ batteryLevel, batteryChargingStatus }}
    />
  );
};
